import { connect } from 'react-redux';
import StatementList from 'components/feature/statement-list/statement-list-component';
import {
  softDeleteCurrentRevision,
  softDeleteAllRevisions,
  permanentlyDeleteRevision,
  permanentlyDeleteAllSoftDeletedRevisionsForStatement,
  navigateToStatement,
  setUploadedFilesAddRevision,
  setUploadedFilesAddRevisionError,
  uploadRevision,
  requestStatementListWithParams,
  requestGetStatementList,
  copyStatement,
} from 'store/actions/statement-list/statement-list-actions';
import {
  updatePinDetails,
  updateUnpinDetails,
} from 'store/actions/pinned-details-actions';
import { fetchRevisionHistory } from 'store/actions/revision-actions';

const mapStateToProps = ({
  data,
  ui: {
    statementPage: { statementWorkflowSteps },
  },
}) => {
  const {
    currentUser,
    pinnedDetails,
    revisionHistory,
    statementList: {
      statementList,
      statementListFilters: { selectedTab, sort },
      revision,
    },
    workflowsMap,
    selectedProject: { project },
    opmService,
  } = data;
  return {
    statementList,
    project,
    selectedTab,
    sortModel: sort,
    revisionInProgress: revision,
    workflowsMap,
    currentUser,
    pinnedDetails,
    statementWorkflowSteps,
    revisionHistory,
    stateData: data,
    isOpmDown: opmService?.isServiceDown ?? false,
  };
};

const mapDispatchToProps = {
  softDeleteCurrentRevision,
  softDeleteAllRevisions,
  permanentlyDeleteAllSoftDeletedRevisionsForStatement,
  permanentlyDeleteRevision,
  navigateToStatement,
  selectTabAndGetStatements: requestStatementListWithParams,
  setUploadedFilesAddRevision,
  setUploadedFilesAddRevisionError,
  uploadRevision,
  requestSortedStatementList: requestStatementListWithParams,
  refreshStatementList: requestGetStatementList,
  copyStatement,
  updatePinDetails,
  updateUnpinDetails,
  fetchRevisionHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(StatementList);
